import { combineReducers } from 'redux'

import agreements from './agreements'
import forms from './forms'

export default combineReducers({
  agreements,
  forms,
})
